// React query configurations and utilities
export const STALE_TIMES = {
  FAST: 1 * 60 * 1000,
  NORMAL: 5 * 60 * 1000,
  SLOW: 15 * 60 * 1000,
};

// Retry configurations for different operation types
export const RETRY_CONFIG = {
  DEFAULT: {
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  },
  FINANCIAL: {
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  },
  CRITICAL: {
    retry: 1,
    retryDelay: 1000,
  },
};

// Pre-configured query options for different data types
export const QUERY_CONFIGS = {
  // For paginated data
  PAGINATED: {
    staleTime: STALE_TIMES.NORMAL,
    keepPreviousData: true,
    ...RETRY_CONFIG.DEFAULT,
  },

  // For financial/wallet data (more conservative)
  FINANCIAL: {
    staleTime: STALE_TIMES.NORMAL,
    ...RETRY_CONFIG.FINANCIAL,
  },

  // For static/profile data
  STATIC: {
    staleTime: STALE_TIMES.NORMAL,
    ...RETRY_CONFIG.DEFAULT,
  },

  // For critical operations
  CRITICAL: {
    staleTime: STALE_TIMES.NORMAL,
    ...RETRY_CONFIG.CRITICAL,
  },
};
